const prepaidPortalStyle = {
	
};

export default prepaidPortalStyle;
